import { render, staticRenderFns } from "./UpdateMark.vue?vue&type=template&id=1e2e018e&"
import script from "./UpdateMark.vue?vue&type=script&lang=js&"
export * from "./UpdateMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports